

























































































































export const enum ViewState {
  select = 'select',
  setting = 'setting'
}

import { ValidationObserver } from "vee-validate";
import { Vue, Component, PropSync, Prop, Emit, Watch } from 'vue-property-decorator';

import ConfigField from "../ConfigField/ConfigField.vue";
import HelpMessage from "../HelpMessage/HelpMessage.vue";
import Icon from "../Icon/Icon.vue";
import WizardLikeListItems from "./WizardLikeListItems.vue";
import { WizardLikeList, IWizardLikeListItem } from "./types";

@Component({
  components: {
    HelpMessage,
    WizardLikeListItems,
    ValidationObserver,
    Icon,
    ConfigField
  }
})
export default class WizardLikeSelect extends Vue {
  @PropSync('isModalActive') isModalVisible!: boolean

  @PropSync('inputItemKey') initItem!: IWizardLikeListItem['key'] | null

  @Prop() items!: WizardLikeList

  @Prop() prefix!: string

  @Prop() footerDisableButtonTitle!: string

  @Prop({ type: Boolean, default: false }) hasFooterDisableButton!: boolean

  @Prop({ type: Boolean, default: true }) hasFooter!: boolean

  @Prop({ type: Function, required: false }) saveClick!: (selected: IWizardLikeListItem['key'] | null, closeModalCallback: () => void) => void

  @Emit()
  onSelectItem(item:IWizardLikeListItem | null): IWizardLikeListItem['key'] | null {
    this.activeItem = item

    return item?.key ?? null
  }

  @Emit()
  onSaveClick() {
    this.isModalVisible = false

    return this.activeItem?.key ?? null
  }

  @Emit()
  modalClose() {
    return null
  }

  @Emit()
  onDisableClick() {
    return null
  }

  @Watch('initItem')
  onInputItemChange(key: IWizardLikeListItem['key'] | null) {
    if (key) {
      let keyItem: IWizardLikeListItem | null = null

      for (const group of this.items) {
        if (keyItem) {
          break
        }

        for (const item of group.items) {
          if (item.key === key)  {
            keyItem = item

            break
          }
        }
      }

      if (keyItem) {
        this.selectItem(keyItem)

        this.isModalVisible = true
        this.modalViewState = ViewState.setting
      }
    }
  }

  modalViewState: ViewState = ViewState.select

  activeItem: IWizardLikeListItem | null = null

  get modalWidth() {
    if (!this.$screen.md) {
      return '95%'
    } else if (!this.$screen.xl) {
      return '70%'
    } else {
      return '55%'
    }
  }

  get backButtonTitle() {
    return this.$t(this.getFullTranslationKey('modal_state_setting_back_button'))
  }

  get modalTitle() {
    return this.$t(this.getFullTranslationKey('modal_state_select_one_of_type'))
  }

  get modalMiniHelpMessage() {
    const k = this.getFullTranslationKey('modal_state_select_one_of_type_mini_help_message')

    return this.$te(k) ? this.$t(k) : null
  }

  getFullTranslationKey(key: string) {
    if (this.prefix) {
      return `${ this.prefix }${ key }`
    }

    return key
  }

  handleSaveClick() {
    if (typeof this.saveClick === 'function') {
      this.saveClick(this.activeItem?.key ?? null, () => this.isModalVisible = false)
    } else {
      this.onSaveClick()
    }
  }

  selectItem(item:IWizardLikeListItem | null) {
    this.modalViewState = ViewState.setting

    this.onSelectItem(item)
  }

  onBackClick() {
    this.modalViewState = ViewState.select;

    this.onSelectItem(null)
  }

  onModalClose() {
    this.activeItem = null
    this.initItem = null

    this.modalViewState = ViewState.select

    this.modalClose()
  }
}
